const setHouseSection2 = (payload) => {
  return {
    type: "setHouseSection2",
    payload,
  };
};
export default setHouseSection2;
